export default __webpack_public_path__ + "static/media/starters.0889be89.png";